export const clusterMixpanelEvent = {
    EXPORT_CTA: "KP Export CTA",
    SORT_FILTERS: "KP Sort and Filters",
    CREATE_SEO_ARTICLE: "KP Create SEO Article",
    CREATE_REPORT: "KP Create Report",
    OPEN_REPORT: "KP Open Report",
    OPEN_CLUSTER: "KP Open Cluster",
};
